const getDefaultState = () => {
  return {
    userInfo: {},
    authToken:
      "Bearer H4sIAAAAAAAAAJVVyZaqSBD9o3cSEKpY9EIFlDwv0waTTGDH4MBYdY4Dwtd3JIpP+9Sie+GCjOHeiBsR7np8TFdZsSnmxdYhPWVR8XuJ0S6c39/qPHBb9NevHThGKr3mQkes5eeo4b1bfhXEmnfyR0v35hZdEammkrZ+vwvoNV4FkMTtyeDJpGWqKl0k9O84JMWmPRXxykHR1jWEdioiQctU45d8Dbb6/OE2TvnIheOla7ilLXM8OfCQ1llVV+8cDsPIYcpl68dUSA4Y+zaPmF1vtgo5MMe3/+WnpALXWSFxgoFYnraxAGmI3jC9xrkk6FlXt2HzGx2CH3yeuFseADYHzACqeMV0fD0b8+Al5xSzirOgd08vdVvQK5qH/jG/+23Yu53l0L9c9rLAMWC889BwHYV+HdsOGntUznuyRDdSoI5uoVfWV7exvtBmOVOJ9R7LNNxuhSdrvLmtkoPtmjW5lYS+LnN5QtaHe9AO+Jh9jO5xWVuNPBOR11lTH2W9KeTyND7k9s9aSbsPdcRb2Xu3A55nwtwzsYID8DKIdTCodbjQcv7uz3mXL/9HjFCOiegkP1Cfex6nlhd0mmfn1Atq8ruif7NnPQ+uf74vEZp0cItHP3Da0E0ulCIO3df3TSSUWsZvA98R9g20PTPXvgX+8pFPWXylqj76TPwC7anzIm2cc9Ti45ttzQfpLwLOXt77WPBRX15VE36wCxdjbraqz4mcgeWCJMIpEnH7ztdPP56pvH/o3D10Ucl9z6Q9jAUeZPzEM2vMU8yfc7vwbQWzAmpq8TVd8eee7jmSb3WmLa5pS2tPNau7vvPunocP2cq8AD6NQ9gymBeJEWgcZhtsPTblvchDiuBm/LDnj1sj52plnuMQP3se2A7zkENcm9v+qB/cKlGfpM0HPSY7RYs1CxzMlrrFECre8f5zTJOEeHi5M9NcSdspgnwMtBxrryY+yjVq6lMcvN4cd6BWBTtZ6ZRl8vbI+B5608GcDPGfW9qRpfvWWyagX6rTjhg1VWCHwTbu8/ddj/lD26gf57nlA/TrMvWLlATBHYNfpdAhm9FRT4omTeIVV2WvE9BJfmchhztuXh5vcvZusGcaYWRGRxy7A+x6t4Y/kNJWaRlpgI1GDmxh/jLS2WeKdp9JqmdZkqV6qnzud2au6XvF/PxQdSMxsjxJ1cTc60amKYaWKh+GaSZZsp99KP8AKByHpLIGAAA=",
    uploadedImage: ""
  };
};

export const namespaced = true;

export const state = getDefaultState();

export const getters = {
  getUserInfo: state => {
    return state.userInfo;
  },
  getAuthToken: state => {
    return state.authToken;
  },
  getMobileNumber: state => {
    return state.userInfo.mobilenumber;
  },
  getUploadedImage: state => {
    return state.uploadedImage;
  }
};

export const mutations = {
  SET_USER_INFO(state, payload) {
    state.userInfo = payload;
  },
  SET_USER_MOBILE_NUMBER(state, payload) {
    state.userInfo.mobilenumber = payload;
  },
  SET_UPLOADED_IMAGE(state, payload) {
    state.uploadedImage = payload;
  }
};

export const actions = {};
